import React, { useEffect, useRef, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import {
  Accordion,
  Card,
  Col,
  Container,
  Row,
  Spinner,
  Button,
  Form,
  Alert,
} from "react-bootstrap";
import tool16 from "../Images/tool16.svg";
import tool18 from "../Images/tool18.svg";
import tool19 from "../Images/tool19.png";
import pay from "../Images/pay.png";
import Nav from "./Navbar";
import Footer from "./Footer";
import SideTab from "./Toolstab";
import Seoauditt from "./seoaudit";
import key1 from "../Images/key1.svg";
import key2 from "../Images/key2.svg";
import key3 from "../Images/key3.svg";
import key4 from "../Images/key4.svg";
import key5 from "../Images/key5.svg";
import key6 from "../Images/cardimg5.svg";
import core1 from "../Images/core1.png";
import core2 from "../Images/core2.png";
import core3 from "../Images/core3.png";
import core4 from "../Images/core4.png";
import core5 from "../Images/core5.png";
import core6 from "../Images/core6.png";
import TestimonialPage from "./Testonomialraghar";
import { useNavigate } from "react-router-dom";
import { BASE_URL_API_TRANXT_UAT_API } from "../Utils/Constant";
import { MdContentPaste } from "react-icons/md";
import { basicauth } from "../Utils/Credentials";
import { Helmet } from "react-helmet";

const Seoaudit = () => {
  const jsonLdData = {
    "@context": "https://schema.org",
    "@type": "SoftwareApplication",
    name: "Inspect & Enhance Your Website SEO with SeoBix SEO Inspector",
    url: "https://seobix.com/seo-inspector",
    description:
      "Analyze and optimize your website with SeoBix SEO Inspector. Find SEO problems, fix errors, and boost your search engine rankings effortlessly.",
    applicationCategory: "SEO Tool",
    operatingSystem: "Web",
    offers: {
      "@type": "Offer",
      price: "0",
      priceCurrency: "USD",
      category: "Free SEO Tool",
    },
    publisher: {
      "@type": "Organization",
      name: "SeoBix",
      url: "https://seobix.com",
      logo: {
        "@type": "ImageObject",
        url: "https://seobix.com/Images/Backlinks.png",
        width: 600,
        height: 60,
      },
    },
    breadcrumb: {
      "@type": "BreadcrumbList",
      itemListElement: [
        {
          "@type": "ListItem",
          position: 1,
          name: "SEO Inspector",
          item: "https://seobix.com/seo-inspector",
        },
      ],
    },
    inLanguage: "en",
    keywords: [
      "Website SEO audit tool",
      "SEO analysis software",
      "On-page SEO checker",
      "SEO audit tool for websites",
      "Website optimization software",
      "SEO performance analyzer",
      "Find SEO issues online",
      "Improve website search rankings",
    ],
  };

  return (
    <Container fluid className="p-0" style={{ overflowX: "clip" }}>
      <div>
        <Helmet>
          <title>
            Inspect & Enhance Your Website SEO with SeoBix SEO Inspector
          </title>
          <meta
            name="description"
            content="Analyze and optimize your website with SeoBix SEO Inspector. Find SEO problems, fix errors, and boost your search engine rankings effortlessly."
          />
          <link rel="canonical" href="https://seobix.com/seo-inspector" />

          <meta property="og:type" content="website" />
          <meta property="og:url" content="https://seobix.com/seo-inspector" />
          <meta
            property="og:title"
            content="Inspect & Enhance Your Website SEO with SeoBix SEO Inspector"
          />
          <meta
            property="og:description"
            content="Analyze and optimize your website with SeoBix SEO Inspector. Find SEO problems, fix errors, and boost your search engine rankings effortlessly."
          />
          <meta
            property="og:image"
            content="https://seobix.com/Images/Backlinks.png"
          />

          <meta name="twitter:card" content="summary_large_image" />
          <meta name="twitter:url" content="https://seobix.com/seo-inspector" />
          <meta
            name="twitter:title"
            content="Inspect & Enhance Your Website SEO with SeoBix SEO Inspector"
          />
          <meta
            name="twitter:description"
            content="Analyze and optimize your website with SeoBix SEO Inspector. Find SEO problems, fix errors, and boost your search engine rankings effortlessly."
          />
          <meta
            name="twitter:image"
            content="https://seobix.com/Images/Backlinks.png"
          />

          <script type="application/ld+json">
            {JSON.stringify(jsonLdData)}
          </script>
        </Helmet>
        <Nav />
      </div>

      <Seoauditt />
      <Row className="justify-content-center mt-3" style={{ margin: "0" }}>
        <Col md={10}>
          <Row className="justify-content-between">
            <Content />
            <Col md={3}>
              <div
                className="mb-5"
                style={{
                  position: "sticky",
                  top: "20px",
                  zIndex: 10,
                  background: "#f8f9fa",
                  padding: "1rem",
                  borderRadius: "10px",
                }}
              >
                <h5
                  className="text-center mb-4"
                  style={{
                    fontWeight: "bold",
                    fontSize: "1.3rem",
                    color: "#fff",
                    backgroundColor: "#799EFF",
                    display: "inline-block",
                    padding: "6px 16px",
                    borderRadius: "0.5rem",
                  }}
                >
                  🚀 Explore More SEO Tools
                </h5>
                <SideTab />
              </div>
            </Col>
          </Row>
        </Col>
      </Row>

      <div
        className="m-0 p-0"
        style={{
          overflow: "hidden",
          background:
            "linear-gradient(to right, rgb(175, 221, 255), rgb(255, 255, 255))",
          borderTopRightRadius: "2rem",
          borderTopLeftRadius: "2rem",
        }}
      >
        <Footer />
      </div>
    </Container>
  );
};
const Content = () => {
  const [showMore, setShowMore] = useState(false);

  return (
    <>
      <Col md={8}>
        <p>
          The foundation of any successful website is search engine
          optimization. Using the SeoBix SEO Inspector Tool, you can also
          analyze on-page performance quickly, discover latent or hidden
          problems and growth opportunities in your site. The tool is fully
          guided below together with what it is testing, and its necessity to
          enhance your rankings.
        </p>
        <h2>How to Use the SeoBix SEO Inspector Tool</h2>
        <p>
          <strong>Enter Your Website URL</strong> – Start by pasting the URL of
          the page you want to analyze. The tool instantly begins scanning your
          site, ensuring that no technical or content-related element is missed.
        </p>

        <p>
          <strong>Run the Audit</strong> – With one click, the tool inspects
          your webpage across multiple on-page SEO factors, from titles and
          headings to speed and mobile usability.
        </p>

        <p>
          <strong>View Results</strong> – Within seconds, you’ll get a detailed
          breakdown of strengths and weaknesses, presented in an easy-to-read
          format for quick understanding.
        </p>

        <p>
          <strong>Take Action</strong> – Each issue comes with actionable
          suggestions, so you know exactly what steps to take to improve
          performance and boost search engine rankings.
        </p>

        <div style={{ position: "relative" }}>
          <h3>What Our SEO Inspector Tool Checks</h3>
          <p
            style={{
              maxHeight: showMore ? "none" : "4.2rem",
              overflow: "hidden",
              textOverflow: "ellipsis",
              WebkitLineClamp: 2,
              display: "-webkit-box",
              WebkitBoxOrient: "vertical",
              filter: showMore ? "none" : "blur(2px)",
              transition: "all 0.3s ease",
              marginBottom: showMore ? "1rem" : "2.5rem",
            }}
          >
            The SeoBix SEO Inspector Tool provides a detailed,
            easy-to-understand report that shows the complete health of your
            website. By analyzing on-page SEO, technical factors, and user
            experience, our website audit tool gives you clear steps to improve
            visibility and rankings. Here’s what it checks:
          </p>

          {!showMore && (
            <div
              style={{
                position: "absolute",
                bottom: "0.5rem",
                left: 0,
                right: 0,
                height: "2.5em",
                background:
                  "linear-gradient(to bottom, rgba(255,255,255,0) 0%, rgba(255,255,255,0.8) 100%)",
              }}
            />
          )}
        </div>

        <div className="d-flex justify-content-center">
          {!showMore && (
            <Button
              onClick={() => setShowMore(true)}
              style={{
                padding: "6px 20px",
                backgroundColor: "#fff",
                color: "#0d6efd",
                fontWeight: "600",
                fontSize: "0.95rem",
                border: "2px solid #0d6efd",
                borderRadius: "999px",
                boxShadow: "0 2px 6px rgba(0, 0, 0, 0.05)",
                transition: "all 0.3s ease",
              }}
              onMouseEnter={(e) => {
                e.target.style.backgroundColor = "#0d6efd";
                e.target.style.color = "#fff";
              }}
              onMouseLeave={(e) => {
                e.target.style.backgroundColor = "#fff";
                e.target.style.color = "#0d6efd";
              }}
            >
              Read More
            </Button>
          )}
        </div>

        {showMore && (
          <>
            <h4>Common Keywords</h4>
            <p>
              The SEO Inspector Tool will break down keywords and their use and
              relevance to the intended purpose allowing you to check that the
              content you create exactly matches the content individuals are
              searching for. This enhances the visibility, introduces more
              organic traffic and makes your pages match the user intent.
            </p>

            <h4>Heading Optimization</h4>
            <p>
              The tool goes through your H1, H2, and other headings to ensure
              that they are properly structured, rich in keywords and easy to
              understand. These optimized headings assist search engines in
              understanding what you have written and also enhance easy reading
              to visitors.
            </p>

            <h4>Image ALT Attributes</h4>
            <p>
              The absence of their ALT tags or poor ALT tags works against their
              SEO. Our instrument scans generated imagery content to verify that
              the images have an adequate description, which makes them rank
              higher in the image search ranking and increases access.
            </p>

            <h4>Keyword Density and Content Quality</h4>
            <p>
              It is important to balance the number of keywords that are used
              with the level of difficulty that they create. SEO Inspector Tool
              detects keyword stuffing, content depth, readability, and
              relevance as well to guarantee your pages are not only search
              engine friendly but also user friendly.
            </p>

            <h4>Links Ratio</h4>
            <p>
              Both external and internal links indicate the authority and the
              site architecture. Our in-page search engine analyzes whether this
              is up-to-date or a bad link and the node points out areas that
              could have better internal links.
            </p>

            <h4>Title Tags / Meta Descriptions</h4>
            <p>
              The tool identifies that the title is missing, duplicated, or not
              optimally featured in the tool description. Special and
              keyword-enriched titles and descriptions enhance your rates of
              clicks and positions on search results.
            </p>

            <h4>OpenGraph Meta Tags</h4>
            <p>
              Sharing to social is a part of SEO. To make sure your content
              appears beautiful in case we share it on Facebook, LinkedIn or any
              other platforms, our SEO Inspector Tool will check whether you
              have OpenGraph tags that we need.
            </p>

            <h4>Sitemap & Robots.txt Testing</h4>
            <p>
              A well-put sitemap and an adequately set up robots.txt file
              facilitate easier crawling and indexing of your website by the
              search engines. The tool identifies any possible errors that might
              prevent the ranking of important pages.
            </p>

            <h4>Organized Data & Schema Markup</h4>
            <p>
              Reviews, FAQs, and ratings are rich and make more clicks. Our site
              analyzer evaluates your schema markup and proposes what needs to
              be changed to ensure that this MP will improve visibility in
              search engine results.
            </p>

            <h4>Minimize CSS and JavaScript</h4>
            <p>
              Have enormous files that are making your site sluggish. The SEO
              Inspector Tool identifies uncompressed CSS and JavaScript,
              recommending to its users the use of minification that would
              reduce loading times and performance.
            </p>

            <h4>Directory Listings</h4>
            <p>
              This helps the brand to increase domain authority and local
              search. Use the tool to determine the gaps in directory
              opportunities that can be used to enhance your presence on the
              site.
            </p>

            <h4>Secure Connection (HTTPS)</h4>
            <p>
              Google focuses on secure sites. The software will be used to
              verify the presence of an SSLite certificate to provide the
              visitor with confidence and your bond will have better search
              engines.
            </p>

            <h4>Core Web Vitals and Page Speed</h4>
            <p>
              Page speed and user experience play an important role in achieving
              SEO. Our quality of site checker analyse the speed,
              responsiveness, and visual soundness, and offers a solution to aid
              in the ranking and the satisfaction of users.
            </p>

            <div className="d-flex justify-content-center">
              <img
                className="mb-3"
                src={tool19}
                alt="seobix"
                style={{ width: "50vw" }}
              />
            </div>
            <h2>Why You Need the SEO Inspector Tool</h2>
            <p>
              It evaluates your site using more than 200 individual parameters
              of both technical and on-page SEO and a glitch here and there can
              have an impact on ranking and traffic. With SeoBix SEO Inspector
              Tool, you can identify these problems early and make amends to
              prepare your site to be favored by both the search engines and the
              users. This is why this audit tool for websites is necessary:
            </p>

            <h4>1. Increase Organic Rankings</h4>
            <p>
              Greater organic rankings result in increased visibility, increased
              traffic, and greater leads without advertisements. Your site will
              be made more search engine-friendly by rectifying metadata errors,
              surface-level site structure, and fixing any on-page aspects with
              the help of our SEO analysis tool. The instrument offers an
              outline of directions to be followed to raise the Google ranking
              and surpass competitors.
            </p>
            <h4>2. Quicker Indexing e.g. Search Engines</h4>
            <p>
              Without a crawlable site, it will not show up in the search
              results. SEO Inspector Tool recognizes the pages that potentially
              can be blocked such as broken links, sitemaps missing, or redirect
              propagating. By repairing them, you ensure that your content will
              be indexed quickly and will become visible in search engines.
            </p>
            <h4>3. Improve User Experience </h4>
            <p>
              SEO is not only about search engines; search engines, but also
              about your visitors. The On-page SEO analyzer points out that it
              has low-speed pages, ineffective mobile responsiveness, and bad
              design that paves the way to user exasperation. You keep the
              visitors longer and lower bounce rates by enhancing the speed of
              the site, its navigation, and content hierarchy.
            </p>
            <h4>4. Grow Revenue and Internet Traffic</h4>
            <p>
              Traffic is not important until it results in business. The free
              SEO tool can make your website a lead machine by enhancing
              visibility, user experience and optimizing keywords. Repair covert
              SEO issues to create qualified traffic flows and direct the
              visitors to the relevant substance like sign-outs, buy, and
              sources.
            </p>
            <h4>5. Detailed Site Health</h4>
            <p>
              The site health checker feature of our search engine optimization
              Inspector Tool keeps scanning your website for problems related to
              performance, security and indexing. Through this method of
              detecting and fixing mistakes, you have managed to have a
              technically solid and all-optimized site that would be search
              engine-friendly in the long term.
            </p>
            <h2>How Seobix's Free Audit Tool Works</h2>
            <ul>
              <li>Enter Your Website URL in the field above </li>
              <li>Scan Your Site Instantly - No waiting, No Registration </li>
              <li>
                Full Downloaded SEO Report with Actionable Recommendations{" "}
              </li>
            </ul>
            <h2 className="text-center">What Our Users Say </h2>
            <Row className="justify-content-center">
              <Col md={8}>
                <Card className="p-2  text-center">
                  <blockquote className="blockquote mb-0">
                    <p style={{ fontSize: "1.2rem", fontStyle: "italic" }}>
                      "Seobix helped me identify critical errors in minutes.
                      After fixing them, my site jumped 3 volumes within
                      Google!"
                    </p>
                    <footer className="blockquote-footer mt-3 fw-bold text-dark">
                      Amit Raj{" "}
                      <cite title="Source Title">, Digital Marketer</cite>
                    </footer>
                  </blockquote>
                </Card>
              </Col>
            </Row>
            <Row className="justify-content-center mt-3">
              <Col md={8}>
                <Card className="p-2  text-center">
                  <blockquote className="blockquote mb-0">
                    <p style={{ fontSize: "1.2rem", fontStyle: "italic" }}>
                      "Initially, I was quite taken aback at the level of detail
                      included in the audit. The speed and clarity of the report
                      saved me hours of guesswork."
                    </p>
                    <footer className="blockquote-footer mt-3 fw-bold text-dark">
                      Neha Sharma,{" "}
                      <cite title="Source Title">eCommerce Founder</cite>
                    </footer>
                  </blockquote>
                </Card>
              </Col>
            </Row>
            <div
              style={{
                backgroundColor: "#f8f9fa",
                padding: "20px",
                borderRadius: "8px",
                marginTop: "30px",
                textAlign: "center",
              }}
            >
              <h3>Ready to Boost Your Website’s SEO?</h3>
              <p>
                The SeoBix SEO Inspector Tool has taken a leading position in
                assisting you to take control of the performance of your own
                website. Conduct a full SEO audit, identify the hidden,
                underlying SEO problems, and obtain a clear, actionable roadmap
                to higher rankings, traffic, and conversions, all through our
                SEO Inspector Tool.
              </p>
            </div>
            <h2 className="mt-4 mb-3">
              Frequently Asked Questions about the SEO Inspector Tool
            </h2>
            <Accordion defaultActiveKey="0" flush>
              <Accordion.Item eventKey="0">
                <Accordion.Header>
                  1. What is the SEO Inspector Tool?
                </Accordion.Header>
                <Accordion.Body>
                  The SEO Inspector Tool is a site audit tool that is very
                  powerful and is meant to analyze the on-page SEO, technical
                  and general state of your site. It offers practical findings
                  to enhance ranking, visitor numbers as well and user
                  experience.
                </Accordion.Body>
              </Accordion.Item>

              <Accordion.Item eventKey="1">
                <Accordion.Header>
                  2. Is it really free to use the SEO Inspector Tool?
                </Accordion.Header>
                <Accordion.Body>
                  Yes, it is. The Seobix SEO Inspector Tool is free, with
                  absolutely no strings attached, hidden fees, subscriptions, or
                  upgrades. You will be able to run unlimited audits without
                  having to sign up for anything or enter your credit card
                  information. We feel that any website owner should be able to
                  obtain essential SEO insights regardless of whether they pay
                  for it.
                </Accordion.Body>
              </Accordion.Item>

              <Accordion.Item eventKey="2">
                <Accordion.Header>
                  3. Who is going to benefit from the SEO Inspector Tool?
                </Accordion.Header>
                <Accordion.Body>
                  This is a tool that is best suited to business owners,
                  marketers, and SEO experts who wish to attain optimal
                  performance of the website. Whether you are an amateur or a
                  professional, the SEO analysis tool provides step-by-step tips
                  on how to increase the rankings and traffic.
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>

            <div className="d-flex justify-content-center mt-4">
              <Button
                onClick={() => setShowMore(false)}
                style={{
                  padding: "6px 20px",
                  backgroundColor: "#fff",
                  color: "#dc3545",
                  fontWeight: "600",
                  fontSize: "0.95rem",
                  border: "2px solid #dc3545",
                  borderRadius: "999px",
                  boxShadow: "0 2px 6px rgba(0, 0, 0, 0.05)",
                  transition: "all 0.3s ease",
                }}
                onMouseEnter={(e) => {
                  e.target.style.backgroundColor = "#dc3545";
                  e.target.style.color = "#fff";
                }}
                onMouseLeave={(e) => {
                  e.target.style.backgroundColor = "#fff";
                  e.target.style.color = "#dc3545";
                }}
              >
                Hide
              </Button>
            </div>
          </>
        )}
        <Plancard />
        <Trialcards />
        <Related />
        <TestimonialPage />
        <Specialoffer />
        <BackLinkCards />
        <Plancard />
      </Col>
    </>
  );
};
const Plancard = () => {
  const [isYearly, setIsYearly] = useState(false);
  const plans = [
    {
      title: "Free",
      monthly: "$0",
      yearly: "$0",
      Free: "3 Month Free Trial",
      features: ["Limited Access"],
      buttonText: "Buy Plan",
      color: "#e0f2fe",
      border: "#38bdf8",
      image: pay,
    },
    {
      title: "Basic",
      monthly: "$150/mo",
      features: ["5 Projects", "Standard Reports", "Email Support"],
      buttonText: "Buy Plan",
      color: "#e7f5ff",
      border: "#339af0",
      image: pay,
    },
    {
      title: "Standard",
      monthly: "$350/mo",
      features: ["10 Projects", "Advanced Reports", "Priority Support"],
      buttonText: "Buy Plan",
      color: "#e6fcf5",
      border: "#20c997",
      image: pay,
    },
    {
      title: "Premium",
      monthly: "$750/mo",
      features: ["Unlimited Projects", "All Features", "24/7 Support"],
      buttonText: "Buy Plan",
      color: "#fff3bf",
      border: "#fcc419",
      image: pay,
    },
  ];

  return (
    <Container className="my-5">
      <div className="text-center mb-4">
        <h2 style={{ fontWeight: "700", fontSize: "2rem" }}>
          Boost Your SEO With Our Amazing Plans
        </h2>
        <h4 className="font-weight-bold mb-4" style={{ color: "#441752" }}>
          🚀 Improve Your Rankings —{" "}
          <span style={{ color: "#FC4100" }}>
            Try Our Service Free for 3 Months!
          </span>
        </h4>
        <p style={{ color: "#6b7280" }}>
          Flexible pricing plans designed for every stage of your journey
        </p>
        <div className="d-flex justify-content-center mt-4">
          <div className="d-flex align-items-center gap-2">
            <span style={{ fontWeight: "500" }}>Monthly</span>

            <div
              className="m-2"
              style={{ transform: "scale(1.5)", transformOrigin: "center" }}
            >
              <Form.Check
                type="switch"
                id="custom-switch"
                checked={isYearly}
                onChange={() => setIsYearly(!isYearly)}
              />
            </div>

            <div className="d-flex align-items-center gap-2">
              <span style={{ fontWeight: "500" }}>Yearly</span>

              <div
                className="start-now-btn mx-3"
                style={{
                  backgroundColor: "#e6f4ea",
                  color: "#2f855a",
                  padding: "6px 12px",
                  borderRadius: "8px solid",
                  fontWeight: "600",
                  fontSize: "0.9rem",
                  border: "1px solid #20c997",
                }}
              >
                🎉{" "}
                <span style={{ color: "#0B1D51" }}>
                  Get{" "}
                  <span style={{ color: "#0B1D51" }}>
                    <b>30% OFF</b>
                  </span>{" "}
                  on Yearly Plans
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Row className="g-4 justify-content-center">
        {plans.map((plan, idx) => (
          <Col md={6} lg={3} key={idx}>
            <div style={{ position: "relative" }}>
              {plan.title === "Free" && (
                <div
                  style={{
                    position: "absolute",
                    top: "-12px",
                    left: 0,
                    right: 0,
                    height: "32px",
                    backgroundColor: "#38bdf8",
                    color: "white",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontWeight: "700",
                    fontSize: "1rem",
                    borderTopLeftRadius: "16px",
                    borderTopRightRadius: "16px",
                    zIndex: 2,
                  }}
                >
                  {plan.Free}
                </div>
              )}

              <Card
                className="p-2"
                style={{
                  backgroundColor: plan.color,
                  border: `2px solid ${plan.border}`,
                  borderRadius: "16px",
                  textAlign: "center",
                  height: "100%",
                  boxShadow:
                    plan.title === "Free"
                      ? "0 12px 28px rgba(56, 189, 248, 0.5)"
                      : "0 4px 12px rgba(0,0,0,0.05)",
                  marginTop: plan.title === "Free" ? "16px" : "0",
                }}
              >
                <Card.Body>
                  <Card.Title style={{ fontSize: "1.5rem", fontWeight: "700" }}>
                    {plan.title}
                  </Card.Title>
                  <h3 style={{ fontWeight: "bold", margin: "1rem 0" }}>
                    {isYearly
                      ? plan.title === "Free"
                        ? plan.yearly
                        : (() => {
                            const monthlyPrice = parseFloat(
                              plan.monthly.replace(/[^0-9.]/g, "")
                            );
                            const yearlyRaw = monthlyPrice * 12;
                            const discounted = yearlyRaw * 0.7;
                            return `$${Math.round(discounted)}/yr`;
                          })()
                      : plan.monthly}
                  </h3>
                  <a
                    href="/register"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      display: "inline-block",
                      backgroundColor: plan.border,
                      color: "white",
                      textDecoration: "none",
                      borderRadius: "999px",
                      padding: "8px 20px",
                      fontWeight: "600",
                      marginTop: "1rem",
                    }}
                  >
                    {plan.buttonText}
                  </a>

                  <div className="mt-3">
                    <img
                      src={plan.image}
                      alt={plan.title}
                      style={{
                        // width: "15vw",
                        objectFit: "contain",
                        marginBottom: "1rem",
                      }}
                    />
                  </div>
                </Card.Body>
              </Card>
            </div>
          </Col>
        ))}
      </Row>
    </Container>
  );
};
const Trialcards = () => {
  const cardsData = [
    {
      keyImg: key1,
      coreImg: core5,
      title: "Integrated Search Console, Google Trends and Google Analytics",
      desc: "Smarter SEO insights in one place and see what’s popular in different countries and other website matrics. Seobix makes it easy and effective.",
    },
    {
      keyImg: key2,
      coreImg: core4,
      title: "Search Engine Optimization",
      desc: "SEO gets easier with SeoBix whether you just start your website or growing your online presence. Our all-in-one SEO tool helps you fix issues and improve online visibility.",
    },
    {
      keyImg: key3,
      coreImg: core2,
      title: "Social Media Optimization",
      desc: "You can monitor and post from all your favorite platforms, YouTube, Facebook, LinkedIn, and Instagram, all from under one roof.",
    },
    {
      keyImg: key4,
      coreImg: core1,
      title: "Competitive Research Overview",
      desc: "You can check domain overview and website age and how their pages look on Google with our SERP Simulator. Seobix gives you the insights you need to compete smarter, not harder.",
    },
    {
      keyImg: key5,
      coreImg: core3,
      title: "Structure Data",
      desc: "With the right setup, At Seobix, we make it super easy to add and check structured data, so your site gets noticed for all the right reasons.",
    },
    {
      keyImg: key6,
      coreImg: core6,
      title: "Keyword Research",
      desc: "Our Bix keyword Research helps you discover high-potential keywords your audience is actually searching for.",
    },
  ];
  return (
    <div className="mt-md-5 mt-3 m-md-0 m-2 ">
      <h2
        className="text-center m-4"
        style={{ fontWeight: "700", fontSize: "2rem" }}
      >
        What Includes In All Plans ?
      </h2>
      <div className="row m-0 p-0">
        {cardsData.map((card, index) => (
          <div key={index} className="col-12 col-md-4 p-2 d-flex">
            <div className="card w-100 h-100 p-2">
              <div className="d-flex h-100">
                <div
                  style={{ flex: 1 }}
                  className="d-flex flex-column position-relative"
                >
                  <div>
                    <img
                      src={card.keyImg}
                      alt={card.title}
                      style={{
                        height: "5vh",
                        objectFit: "contain",
                        marginBottom: "0.5rem",
                      }}
                    />
                    <h5>{card.title}</h5>
                  </div>
                </div>

                <div
                  style={{ flex: 1 }}
                  className="d-flex align-items-center justify-content-center"
                >
                  <img
                    src={card.coreImg}
                    alt={card.title}
                    className="img-fluid"
                    style={{ maxHeight: "200px", objectFit: "contain" }}
                  />
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
const Specialoffer = () => {
  return (
    <div
      className="start-now-btn p-2"
      style={{
        background: "#799EFF",
        borderRadius: "24px",
        color: "white",
        textAlign: "center",
        margin: "3rem auto",
        width: "90%",
        maxWidth: "1000px",
        position: "relative",
      }}
    >
      <h2 className="mb-3" style={{ fontSize: "2rem", fontWeight: "bold" }}>
        Let’s do this! Start unlocking powerful backlink insights.
      </h2>

      <div
        style={{
          display: "flex",
          justifyContent: "center",
          gap: "16px",
          flexWrap: "wrap",
        }}
      >
        <a
          // href="/register"
          onClick={() => window.open("https://dashboard.seobix.com/", "_blank")}
          style={{
            backgroundColor: "#fff",
            color: "#000",
            padding: "12px 24px",
            borderRadius: "12px",
            fontWeight: "600",
            textDecoration: "none",
            minWidth: "150px",
            textAlign: "center",
          }}
        >
          Start 3 Months Free Trial
        </a>
      </div>

      <p style={{ color: "#fff", marginTop: "20px", fontSize: "14px" }}>
        <b> Full access — No Credit card Needed.</b>
      </p>
    </div>
  );
};
const Related = () => {
  const navigate = useNavigate();
  const handleClick = () => {
    navigate("/bix-content-generator");
  };
  const resultRef = useRef(null);
  const [content, setContent] = useState("");
  const [generatedText, setGeneratedText] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [displayedText, setDisplayedText] = useState("");
  const [animationIndex, setAnimationIndex] = useState(0);
  const { password, username } = basicauth;
  const base64Credentials = btoa(`${username}:${password}`);

  const handleAnalyze = async () => {
    setError(null);
    setLoading(true);
    setGeneratedText("");

    if (!content.trim()) {
      setError("Please paste some content before analyzing.");

      setLoading(false);
      return;
    }

    try {
      const response = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/Seo/GetGenerativeTexts`,
        {
          method: "POST",
          headers: {
            Authorization: `Basic ${base64Credentials}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            meta_name: "Title",
            relational_text: `Please generate content on topic ${content}`,
            type: "1",
          }),
        }
      );

      const data = await response.json();
      const text = data?.candidates?.[0]?.content?.parts?.[0]?.text;
      if (text) {
        setGeneratedText(text);
        setDisplayedText("");
        setAnimationIndex(0);
        setTimeout(() => {
          resultRef.current?.scrollIntoView({ behavior: "smooth" });
        }, 200);
      } else {
        setError("Failed to generate content.");
      }
    } catch (err) {
      console.error("API Error:", err);
      setError("An error occurred while generating the content.");
    }

    setLoading(false);
  };
  useEffect(() => {
    if (!generatedText) return;

    const words = generatedText.split(" ");
    if (animationIndex < words.length) {
      const timeout = setTimeout(() => {
        setDisplayedText(words.slice(0, animationIndex + 1).join(" "));
        setAnimationIndex((prev) => prev + 1);
      }, 80);

      return () => clearTimeout(timeout);
    }
  }, [animationIndex, generatedText]);
  const renderFormattedText = (text) => {
    const lines = text.split("\n");
    return lines.map((line, index) => {
      if (line.startsWith("## ")) {
        return (
          <h4 key={index} style={{ fontWeight: "bold", marginTop: "1rem" }}>
            {line.replace("## ", "")}
          </h4>
        );
      } else if (line.startsWith("**") && line.endsWith("**")) {
        return (
          <p key={index} style={{ fontWeight: "bold" }}>
            {line.replace(/\*\*/g, "")}
          </p>
        );
      } else if (line.trim().startsWith("* ")) {
        return (
          <ul key={index} style={{ paddingLeft: "1.2rem" }}>
            <li>{line.replace("* ", "")}</li>
          </ul>
        );
      } else {
        return <p key={index}>{line}</p>;
      }
    });
  };
  return (
    <div className="mt-5 mb-5">
      <div
        // onClick={handleClick}
        style={{
          cursor: "pointer",
        }}
      >
        <Row
          className="justify-content-center"
          style={{
            margin: "0",
            background:
              "linear-gradient(to right, #AFDDFF 0%, #C5E7FF 30%, #DAF0FF 60%, #EDF8FF 85%, #FFFFFF 100%)",
            borderRadius: "12px",
            transition: "transform 0.2s ease",
          }}
          onMouseEnter={(e) =>
            (e.currentTarget.style.transform = "scale(1.01)")
          }
          onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
        >
          <Col md={10} className="p-3">
            <h3 className="text-center">
              <b>Generate SEO-Friendly Content Instantly!</b>
            </h3>
            <p className="text-center">
              Enter your topic and get high-quality, optimized content in
              seconds — perfect for blogs, landing pages, and more.
            </p>
          </Col>
          <Form className="">
            <Form.Group
              className="m-4"
              controlId="contentTextarea"
              style={{ position: "relative" }}
            >
              <MdContentPaste
                style={{
                  position: "absolute",
                  top: "18px",
                  left: "20px",
                  fontSize: "1.5rem",
                  color: "#ccc",
                  pointerEvents: "none",
                  zIndex: "1",
                }}
              />
              <Form.Control
                as="textarea"
                rows={3}
                placeholder="Enter your topic here..."
                value={content}
                onChange={(e) => setContent(e.target.value)}
                style={{
                  fontSize: "1rem",
                  padding: "1.25rem 1.25rem 1.25rem 3rem",
                  border: "1px solid #ccc",
                  borderRadius: "12px",
                  boxShadow: "0 4px 10px rgba(0, 0, 0, 0.15)",
                  transition: "box-shadow 0.3s ease-in-out",
                  resize: "vertical",
                }}
              />
            </Form.Group>

            <Button
              className="m-4"
              variant="primary"
              onClick={handleAnalyze}
              disabled={loading}
            >
              {loading ? <Spinner animation="border" size="sm" /> : "Generate"}
            </Button>
          </Form>
          {error && (
            <Alert variant="danger" className="mt-3">
              {error}
            </Alert>
          )}
          <Col md={10}>
            {generatedText && (
              <div
                ref={resultRef}
                className="mb-4 p-4 rounded"
                style={{ backgroundColor: "#f8f9fa", border: "1px solid #ccc" }}
              >
                <p style={{ whiteSpace: "pre-wrap" }}>
                  {(() => {
                    const fullContent = renderFormattedText(displayedText);

                    let visible = [];
                    let hidden = [];
                    let paragraphCount = 0;
                    let threshold = 6;

                    for (let i = 0; i < fullContent.length; i++) {
                      const el = fullContent[i];
                      const tag = el?.type;

                      if (tag === "p" || tag === "ul" || tag === "h4") {
                        paragraphCount++;
                      }

                      if (paragraphCount <= threshold) {
                        visible.push(el);
                      } else {
                        hidden.push(el);
                      }
                    }

                    return (
                      <>
                        {visible.map((el, idx) => (
                          <div key={`visible-${idx}`}>{el}</div>
                        ))}

                        {hidden.length > 0 && (
                          <div
                            style={{
                              filter: "blur(4px)",
                              overflow: "hidden",
                              maxHeight: "70px",
                              opacity: 0.6,
                              marginTop: "0.5rem",
                            }}
                          >
                            {hidden.slice(0, 2).map((el, idx) => (
                              <div key={`blurred-${idx}`}>{el}</div>
                            ))}
                          </div>
                        )}

                        {hidden.length > 0 && (
                          <div className="text-center mt-3">
                            <Button
                              variant="outline-primary"
                              onClick={handleClick}
                            >
                              View More
                            </Button>
                          </div>
                        )}
                      </>
                    );
                  })()}
                </p>
              </div>
            )}
          </Col>
        </Row>
      </div>
    </div>
  );
};
const cardData = [
  {
    title: "Top Pages",
    description:
      "Compare and analyze the performance of your most linked pages and that of your competitors. Learn about high-impact SEO opportunities.",
    linkText: "Top Pages",
    linkUrl: "/top-pages",
    bgColor: "#dff5ff",
  },
  {
    title: "Link Building Tool",
    description:
      "Determine broken or lost backlinks and turn them into new opportunities to establish stronger relations.",
    linkText: "Link Building Tool",
    linkUrl: "/link-building-tool",
    bgColor: "#f4f7fb",
  },
  {
    title: "Domain Authority",
    description:
      "Assess the authority rating and any future search engine of a web site with more than 15 reliable ranking factors and domain measures.",
    linkText: "DA Checker",
    linkUrl: "/da-pa-checker",
    bgColor: "#d6ffd6",
  },
];
const BackLinkCards = () => {
  return (
    <div style={{ overflow: "hidden", padding: "20px" }}>
      <div className="container">
        <div className="text-center mb-5">
          <h2 className="fw-bold">
            Backlink Optimization Toolkit: Everything You Need
          </h2>
        </div>
        <div className="row justify-content-center g-4">
          {cardData.map((card, index) => (
            <div key={index} className="col-md-6 col-lg-3 p-1">
              <div
                style={{
                  backgroundColor: card.bgColor,
                  padding: "24px",
                  borderRadius: "20px",
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between",
                }}
              >
                <div>
                  <h5 className="fw-bold">{card.title}</h5>
                  <p className="text-muted" style={{ fontSize: "15px" }}>
                    {card.description}
                  </p>
                </div>
                <div>
                  <a
                    href={card.linkUrl}
                    className="text-primary fw-semibold"
                    style={{ textDecoration: "none" }}
                  >
                    {card.linkText} →
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
export default Seoaudit;
